import React, { useRef } from 'react'
import { useGLTF, Instances, Cloud } from '@react-three/drei'

import ConeFigure from './ConeFigure'
import Ground from 'lib/misc/Ground'
import BaseCanvas from 'bundles/Cone/components/BaseCanvas';
import InfoBox from 'lib/misc/InfoBox';

const WIDTH = 30;
const DEPTH = -20;

export default function ConeFigures({ range }) {
    const { nodes, materials } = useGLTF('/cone_06.glb')

    const positionData = [];
    for (let z = DEPTH; z < 30; z++) {
        for (let x = -WIDTH; x < WIDTH; x++) {
            let randx = x + Math.random()/2;
            let randz = z + Math.random()/2;
            positionData.push({position: [randx,0,randz], scale: [0.3, 1, 0.3]});
        }
    }

    const hahaZoeSoundRef = useRef();
    const bruderZoeSoundRef = useRef();
    const hihiZoeSoundRef = useRef();
    const dummkopfZoeSoundRef = useRef();
    const iiiZoeSoundRef = useRef();
    const mamaZoeSoundRef = useRef();
    const papaZoeSoundRef = useRef();
    const scheisseZoeSoundRef = useRef();
    const scheisseAntonSoundRef = useRef();
    const superAntonSoundRef = useRef();
    const ahAntonSoundRef = useRef();
    const baehAntonSoundRef = useRef();
    const dreckAntonSoundRef = useRef();
    const jaAntonSoundRef = useRef();
    const neinAntonSoundRef = useRef();
    const schwesterAntonSoundRef = useRef();

    return (
        <>
            <audio id="haha-zoe" ref={hahaZoeSoundRef} src={'/sounds/haha-zoe.mp3'} />
            <audio id="hihi-zoe" ref={hihiZoeSoundRef} src={'/sounds/hihi-zoe.mp3'} />
            <audio id="bruder-zoe" ref={bruderZoeSoundRef} src={'/sounds/bruder-zoe.mp3'} />
            <audio id="dummkopf-zoe" ref={dummkopfZoeSoundRef} src={'/sounds/dummkopf-zoe.mp3'} />
            <audio id="iii-zoe" ref={iiiZoeSoundRef} src={'/sounds/iii-zoe.mp3'} />
            <audio id="mama-zoe" ref={mamaZoeSoundRef} src={'/sounds/mama-zoe.mp3'} />
            <audio id="papa-zoe" ref={papaZoeSoundRef} src={'/sounds/papa-zoe.mp3'} />
            <audio id="scheisse-zoe" ref={scheisseZoeSoundRef} src={'/sounds/scheisse-zoe.mp3'} />
            <audio id="scheisse-anton" ref={scheisseAntonSoundRef} src={'/sounds/scheisse-anton.mp3'} />
            <audio id="super-anton" ref={superAntonSoundRef} src={'/sounds/super-anton.mp3'} />
            <audio id="ah-anton" ref={ahAntonSoundRef} src={'/sounds/ah-anton.mp3'} />
            <audio id="baeh-anton" ref={baehAntonSoundRef} src={'/sounds/baeh-anton.mp3'} />
            <audio id="dreck-anton" ref={dreckAntonSoundRef} src={'/sounds/dreck-anton.mp3'} />
            <audio id="ja-anton" ref={jaAntonSoundRef} src={'/sounds/ja-anton.mp3'} />
            <audio id="nein-anton" ref={neinAntonSoundRef} src={'/sounds/nein-anton.mp3'} />
            <audio id="schwester-anton" ref={schwesterAntonSoundRef} src={'/sounds/schwester-anton.mp3'} />
            <audio id="cones" src={'/sounds/cones.m4a'} autoPlay controls />

            <BaseCanvas
                position={[0, 8, 0]}
                minDistance={5}
                maxDistance={8}
                minAzimuthAngle={-0.3}
                maxAzimuthAngle={0.3}
                minPolarAngle={1.3}
                maxPolarAngle={1.4}
            >
                <Cloud
                    texture={'/textures/cloud.png'}
                    width={60}
                    color={'#36706a'}
                    speed={0.03}
                    depth={1}
                    opacity={0.1}
                    segments={800}
                />
                <Instances limit={positionData.length} material={materials.Material} geometry={nodes.Cylinder.geometry}>
                    {positionData.map((props, i) => {
                        return (
                            <ConeFigure
                                key={i}
                                index={i}
                                hahaZoeSoundRef={hahaZoeSoundRef}
                                bruderZoeSoundRef={bruderZoeSoundRef}
                                hihiZoeSoundRef={hihiZoeSoundRef}
                                dummkopfZoeSoundRef={dummkopfZoeSoundRef}
                                iiiZoeSoundRef={iiiZoeSoundRef}
                                mamaZoeSoundRef={mamaZoeSoundRef}
                                papaZoeSoundRef={papaZoeSoundRef}
                                scheisseZoeSoundRef={scheisseZoeSoundRef}
                                scheisseAntonSoundRef={scheisseAntonSoundRef}
                                superAntonSoundRef={superAntonSoundRef}
                                ahAntonSoundRef={ahAntonSoundRef}
                                baehAntonSoundRef={baehAntonSoundRef}
                                dreckAntonSoundRef={dreckAntonSoundRef}
                                jaAntonSoundRef={jaAntonSoundRef}
                                neinAntonSoundRef={neinAntonSoundRef}
                                schwesterAntonSoundRef={schwesterAntonSoundRef}
                                {...props}
                            />
                        )
                    })}
                </Instances>
                <Ground
                    texturePath='/textures/asphalt.jpg'
                    repeat={30}
                    depth={90}
                />
            </BaseCanvas>
            <InfoBox
                title="Cones"
                position={[1, -2, 0]}
            >
                <ul>
                    <li>Cone(s) modeled and textured with Blender.</li>
                    <li>Put together with React Three Fiber.</li>
                    <li>Biggest thanks for the sounds (on click) from my children Anton and Zoé.</li>
                    <li>And biggest thanks for the ambient background sound from Hanz Weizenegger.</li>
                </ul>
            </InfoBox>
        </>
    )
}

